import React, { Fragment, useEffect, useState } from "react";
import {
  Input,
  Button,
  Label,
  FormFeedback,
  Form,
  FormGroup
} from "reactstrap";
import { connect } from "react-redux";
import {
  addZone,
  clearZoneError,
  createZone
} from "../../store/zones/actions";
import Message from "../../CommonData/Data/Message";
import { addZoneForm } from "../../store/form/actions";
import VWLoading from "../../components/vwLoading/vwLoading";

const AddZone = (props) => {

  const { handleClose, errorMessage, form, isCreatePending } = props;
  const { formAddZone } = form || {};
  const { zoneName } = formAddZone || {};

  useEffect(() => {
    props.addZoneForm({
      formAddZone: {},
      errors: {}
    })
    props.clearZoneError();
    //--------------------Key-Listener----------------------
    const handleKeyPress = (e) => {
      if (e.key === "Escape") {
        handleClose();
      }
    };

    window.addEventListener('keydown', handleKeyPress);

    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, [])


  const handleInputChange = (event) => {
    const { name, value } = event.target;
    props.addZoneForm({
      formAddZone: {
        ...form.formAddZone,
        [name]: value
      },
      errors: {
        ...form && form.errors,
        [name]: null,
      }
    });
  }

  const handleCreateZone = (e) => {
    e.preventDefault();
    const { formAddZone } = form || {};
    const { zoneName } = formAddZone || {};
    const currentErrors = {};

    if (!zoneName) {
      currentErrors.zoneName = "Name is required"
    }

    props.addZoneForm({
      formAddZone: {
        ...form.formAddZone,
      },
      errors: currentErrors,
    })

    if (Object.keys(currentErrors).length === 0) {
      props.createZone(form.formAddZone);
    }
  };

  return isCreatePending ? <VWLoading /> : (
    <Fragment>
      {errorMessage && (
        <Message
          type="danger"
          defaultMessage={errorMessage}
          baseClassName="alert"
        />
      )}
      <Form className="mb-3" name="formAddZone" onSubmit={handleCreateZone}>
        <FormGroup>
          <Label>Zone Name<span className="text-danger">*</span></Label>
          <Input
            autoFocus
            type="text"
            name="zoneName"
            placeholder="Enter zone name"
            onChange={handleInputChange}
            value={zoneName || ""}
            invalid={form && form.errors && form.errors.zoneName}
          />
          <FormFeedback>{form && form.errors && form.errors.zoneName}</FormFeedback>
        </FormGroup >
        <FormGroup>
          <Button
            type="submit"
            className='me-4'
            color="success"
            onClick={handleCreateZone}
          >Create</Button>
          <Button
            color="danger"
            onClick={handleClose}
          >Cancel</Button>
        </FormGroup>
      </Form >
    </Fragment >
  );
}

const mapStateToProps = (state) => ({
  form: state.form.zoneForm,
  AddZoneForm: state.zones.AddZoneForm,
  isCreatePending: state.zones.isCreatePending,
  errorMessage: state.zones.errorMessage,
});

const mapDispatchToProps = (dispatch) => ({
  addZoneForm: (AddZoneForm) => dispatch(addZoneForm(AddZoneForm)),
  addZone: (AddZoneForm) => dispatch(addZone(AddZoneForm)),
  createZone: (addZone) => dispatch(createZone(addZone)),
  clearZoneError: () => dispatch(clearZoneError()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddZone);